import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ChangeDetectorRef, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, throwError, finalize, Observable, of, Subject, takeUntil, tap, firstValueFrom, map } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { UserService } from 'src/app/services/user.service';
import { MemberService } from 'src/app/services/member.service';
import { Member, MemberDatum, MemberModel, MemberProfileSaveRequest, Registration, RegistrationProfile } from 'src/app/models/member';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import parsePhoneNumber from 'libphonenumber-js';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { CountryOptions } from '../../models/country-codes';
import { environment } from 'src/environments/environment';
import { Utils } from 'src/app/services/common/utils';
import { Address, InterestedPerson, PersonModel, RepositoryResult, Location } from 'src/app/models/common-models';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig } from 'src/environments/environment.interface';
import { InterestedPersonService } from 'src/app/services/interested-person.service';
import { v4 as uuidv4 } from 'uuid';
import { MemberAddressSaveRequest, MemberLocationSaveRequest } from 'src/app/models/requests';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { FacilityService } from 'src/app/services/facility.service';
import { MemberDocument, MemberDocumentAgreeRequest, MemberDocumentRequest } from 'src/app/models/document';
import { DocumentEventType, DocumentIntent } from 'src/app/models/enums';
import { PdfPreviewComponent } from '../popups/pdf-preview/pdf-preview.component';

declare var segment: any;

@Component({
  selector: 'df-login',
  templateUrl: './df-login.component.html',
  styleUrls: ['./df-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {
  profileForm : FormGroup;
  phoneForm : FormGroup;
  agreementForm : FormGroup;
  submitted: boolean = false;
  loginStep: string = 'phone';
  dialCode = '+1';
  phoneValue = '';
  phoneNumber = '';
  codeValue = '';
  registration!: Registration;
  memberInfo!: Member;
  personInfo!: PersonModel;
  addressInfo!: Address;
  isNew = false;
  countries: any[] = CountryOptions.countries;
  countryCode = 'us';
  flagUrl: string = `https://dropfitness-static.nyc3.digitaloceanspaces.com/static/svg/flags/4x3/us.svg`;
  defaultTitle = 'Welcome Back';
  defaultLoginText = 'Please enter your mobile number to verify or create an account.';
  isLoading = false;
  redirectTo: string = '';
  interestedPerson: InterestedPerson | undefined;
  memberDocs: MemberDocument[] = [];
  allowClosingPopup: boolean = true;
  loginErrorMessage: string | null = null;

  @Input()
  modal: any;
  @Input()
  title: string = 'Welcome Back';
  @Input()
  loginText: string = 'Please enter your mobile number to verify or create an account.';

  @Output() loggedIn: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('login', { read: TemplateRef }) login: TemplateRef<any> | undefined;
  
  private readonly _unsubscribe: Subject<any> = new Subject();
  mfaRequest: Object | undefined;
 
	separateDialCode = false;
  context: any = undefined;
  locations: Location[] = [];
  selectedLocationId: number = 0;
  selectedLocation: Location = { FacilityId: 0, Name: "", Description: "", AddressLine1: "", AddressLine2: "", City: "", State: "", ZipCode: "", Country: "", Phone: "", Email: "", Website: "", Latitude: 0, Longitude: 0, TimeZone: "", TaxRegionId: 0, Order: 0, AverageRating: 0, ReviewCount: 0, PaymentAccountId: '', PaymentLocationId: '', OpeningDate: '', LocationHours: [], LocationImages: [], CreatedAt: new Date(), CreatedBy: '', Guid: '', Id: 0};
  showGetStarted: boolean = false;
  hasProfile: boolean = false;
  facilityConfig: FacilityConfig = {} as FacilityConfig;
  termsOfUseLink: string = '';
  privacyPolicyLink: string = '';
  safetyWaiverLink: string = '';
  logo: string = '';
  genderMap: { [key: string]: string } = {
    'Female': '1',
    'Male': '2',
    'Non-binary': '3',
    'Other': '4'
  };

  constructor(private modalService: NgbModal
    , private _auth: AuthService
    , private _userService: UserService
    , private _memberService: MemberService
    , private _environmentService: EnvironmentService
    , private _router: Router
    , private _interestedPersonService: InterestedPersonService
    , private localStorageService: LocalStorageService
    , private _facilityService: FacilityService
    , private cdRef: ChangeDetectorRef
    ) {
      
}

  async ngOnInit(): Promise<void> {
    this.personInfo = new PersonModel();
    this.facilityConfig = this._environmentService.getFacilityConfig();
    this.termsOfUseLink = this._environmentService.getLinkUrlById('termsAndConditions')
      || this._environmentService.getLinkUrlById('termsOfUse');
    this.privacyPolicyLink = this._environmentService.getLinkUrlById('privacyPolicy');
    this.safetyWaiverLink = this._environmentService.getLinkUrlById('liabilityRelease')
      || this._environmentService.getLinkUrlById('safetyWaiver');
    this.logo = this._environmentService.getLinkUrlById('smallLogo');
    this.locations = await this._facilityService.getLocations();
    this.isLoading = true;
    if(this.title === '')
      this.title = this.defaultTitle;
    if(this.loginText === '')
      this.loginText = this.defaultLoginText;

    this.phoneNumber = this.localStorageService.getProp('df-auth-key', 'PhoneNumber');
    this.applyDialCountry(
      this.localStorageService.getProp('df-auth-key', 'DialCode') || '+1',
      this.localStorageService.getProp('df-auth-key', 'CountryCode') || undefined
    );
    this.phoneForm = new FormGroup({
      PhoneNumber: new FormControl(this.phoneNumber, Validators.required),
    });

    // Conditionally add address fields
    this.profileForm = new FormGroup({
      LocationId: new FormControl(0, Validators.required),
      FirstName: new FormControl('', Validators.required),
      LastName: new FormControl('', Validators.required),
      Email: new FormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$')]),
      BirthDate: new FormControl('', Validators.required),
      Gender: new FormControl('', Validators.required),
      ZipCode: new FormControl('', Validators.required),
      EmailNotification: new FormControl(true, Validators.required),
      SmsNotification: new FormControl(false, Validators.required),
      AgreeToTerms: new FormControl(false, Validators.required),
    });
    if (this.facilityConfig.collectAddressDuringSignup) {
      this.profileForm.addControl('AddressLine1', new FormControl('', Validators.required));
      this.profileForm.addControl('AddressLine2', new FormControl(''));
      this.profileForm.addControl('City', new FormControl('', Validators.required));
      this.profileForm.addControl('State', new FormControl('', Validators.required));
      this.profileForm.addControl('Country', new FormControl('us', Validators.required));
    }

    this.agreementForm = new FormGroup({
      AgreeToTerms: new FormControl(false, Validators.required),
    });

    // Subscribe to LocationId changes to save location to localStorage and call changeLocation API
    this.profileForm.get('LocationId')?.valueChanges.pipe(
      takeUntil(this._unsubscribe)
    ).subscribe(async (locationId: number) => {
      if (locationId && locationId > 0) {
        try {
          const location: Location = await this._facilityService.getLocationById(locationId);
          this.localStorageService.setLocation(location);
          
          // Call changeLocation API if member is logged in
          if (this.memberInfo && this.memberInfo.Id) {
            const request: MemberLocationSaveRequest = {
              MemberId: this.memberInfo.Id,
              LocationId: locationId
            };
            this._facilityService.changeLocation(request).pipe(
              takeUntil(this._unsubscribe),
              catchError((err) => {
                console.error('Error changing location:', err);
                return of(null);
              })
            ).subscribe((member: Member | null) => {
              if (member) {
                // Update memberInfo with the response
                this.memberInfo = member;
                this._auth.setProp('member', member);
              }
            });
          }
        } catch (err) {
          console.error('Error fetching location:', err);
        }
      }
    });

    this.phoneChange();
    this.cdRef.detectChanges();
    this.isLoading = false;
  }

  public open(metaData: any = null, phone = '', step = 'phone', redirectTo: string = ''): void {
    this.loginStep = step;
    this.context = metaData;
    this.showGetStarted = !!phone;
    this.hasProfile = false;
    this.redirectTo = redirectTo;
    
    this.openModal(this.login, phone, step);
  }

  public dismiss() {
    if(this.redirectTo && this.redirectTo !== '')
    {
      const [path, queryString] = this.redirectTo.split('?');
      const queryParams: any = {};
      if (queryString) {
        queryString.split('&').forEach(pair => {
          const [key, value] = pair.split('=');
          queryParams[key] = value;
        });
      }
      // Close modal first, then navigate
      this.modalService.dismissAll();
      this._router.navigate([path], { queryParams });
      return;
    }
    this.modalService.dismissAll();
  }

  public async openModal(modal: any, phone = '', step = 'phone'): Promise<void> {
    this.submitted = false;
    this.isLoading = true;

    this.applyDialCountry('+1', 'us');
    this.phoneNumber = phone;
    this.phoneValue = phone;
    this.codeValue = '';
    this.isNew = false;
    this.phoneChange();
    this.loginErrorMessage = null;

    this.loginStep = step;
    this.allowClosingPopup = true;
    
    var isLoggedIn = this._auth.isLoggedIn();
    if(isLoggedIn)
    {
      this.personInfo = this._auth.getProp('user');
      if (this.personInfo) {
        this.phoneNumber = this.personInfo.PhoneNumber || '';
        this.applyDialCountry(this.personInfo.DialCode || '+1');
      } else {
        this.isNew = true;
        this.hasProfile = false;
      }

      var member = this._auth.getProp('member');
      if (!member) {
        const isActive = await this.fetchMemberInfo();
        if (!isActive) return;
      }
    }
    
    if(step === 'register' || step === 'agreement') {
      this.allowClosingPopup = false;
    }

    if(step === 'register') {
      this.registration = await this.getCompeletedRegistrationSteps();
      if (!Utils.hasStepCompleted(this.registration.CompletedSteps, 'profile')) {
        this.newUserCallback();
      } else {
        this.loginStep = 'agreement';
      }
    }

    if(step === 'agreement') {
      this.isLoading = true;
      this.title = 'Agreement';
      const isActive = await this.fetchMemberInfo();
      if (!isActive) return;
      this._interestedPersonService.getInterestedPerson(this.phoneNumber).subscribe({
        next: async (result: InterestedPerson) => {
          if (result) {
            this.interestedPerson = result;
            await new Promise<void>((resolve) => {
              this.getAgreementDocuments().subscribe(docs => {
                this.memberDocs = docs;
                if(this.memberDocs.filter(doc => !doc.AgreeStatus).length === 0) {
                  this.showWelcome();
                }
              });
            });
          }
        },
        error: (error) => {
          console.error('Error fetching interested person:', error)
          this.isLoading = false;
        },
        complete: () => {
          this.isLoading = false;
        }
      });
    }
    this.submitted = false;
    this.isLoading = false;
    let modalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title', 
      // size: 'lg',
      centered: true,
      fullscreen: window.innerWidth <= 768,
      backdrop: 'static', // Prevent closing on outside click
      keyboard: false
      // windowClass: 'custom-class'
    });
    modalRef.shown.subscribe(() => {
      if (phone) {
        this.phoneForm.setValue({ PhoneNumber: phone });
      }
    });
  }

  async enterPhone() {
    this.loginErrorMessage = null;
    segment.track(segment.TRACK_EVENTS.regStep1, {
      phone: this.dialCode + this.phoneNumber
    });
    this.submitted = true;
    this.isLoading = true;
    this._auth.login(this.phoneNumber, this.dialCode)
      .pipe(
        takeUntil(this._unsubscribe),
        catchError((err: any) => {
          if (err.status === 428) {
            this.hasProfile = true;
            this.loginStep = 'verify';
            this.allowClosingPopup = true;
            this.submitted = false;
            return of([]);
          }
          const isDeletedOrInvalidMember =
            err.status === 401 ||
            err.status === 404 ||
            err.status === 410 ||
            (err.status === 400 && err?.error && typeof err.error === 'object' && /invalid|deleted/i.test(JSON.stringify(err.error)));
          if (isDeletedOrInvalidMember) {
            this.isNew = true;
            return this.signupMember(this.phoneNumber, this.dialCode).pipe(
              catchError((signupErr: any) => {
                this.submitted = false;
                this.isLoading = false;
                return throwError(signupErr);
              })
            );
          }
          return throwError(err);
        }),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: async (jwt: any) => {
          if (!jwt || !jwt.access_token) return;
          this.setToken(jwt);
          this.registration = await this.getCompeletedRegistrationSteps();
          if (!Utils.hasStepCompleted(this.registration.CompletedSteps, 'phone')) {
            await this.enterCode();
            return;
          }
          if (!Utils.hasStepCompleted(this.registration.CompletedSteps, 'profile')) {
            const isActive = await this.fetchMemberInfo();
            if (!isActive) return;
            this.fetchUserInfo(
              () => {},
              () => this.newUserCallback()
            );
            return;
          }
          this.loginStep = 'verify';
          this.allowClosingPopup = true;
          this.submitted = false;
          this.isLoading = false;
          await this.enterCode();
        },
        error: () => {
          this.submitted = false;
          this.isLoading = false;
          this.loginErrorMessage = 'Invalid member. You can create a new account with this number.';
        }
      });
    return true;
  }

  async newUserCallback() {
    this.isNew = true;
    this.hasProfile = false;
    this.submitted = false;
    this.loginStep = 'register';
    this.allowClosingPopup = false;
    this.title = 'Complete your profile';
    this.loginText = 'Complete your profile to access all features.';
    this.isLoading = true;
    var isLoggedIn = this._auth.isLoggedIn();
    if(isLoggedIn)
    {
      this.personInfo = this._auth.getProp('user');
      if (this.personInfo) {
        this.phoneNumber = this.personInfo.PhoneNumber || '';
        this.applyDialCountry(this.personInfo.DialCode || '+1');
      } else {
        this.isNew = true;
        this.hasProfile = false;
      }

      var member = this._auth.getProp('member');
      if (!member) {
        const isActive = await this.fetchMemberInfo();
        if (!isActive) return;
      }
    }
    // Fetch interested person details
    this._interestedPersonService.getInterestedPerson(this.phoneNumber).subscribe({
      next: async (result: InterestedPerson) => {
        if (result) {
          this.interestedPerson = result;
          // Only patch values for controls that exist in the form
          this.profileForm.patchValue({
            LocationId: result.LocationId,
            FirstName: result.FirstName,
            LastName: result.LastName,
            Email: result.Email,
            Gender: result.Gender,
            BirthDate: this.isValidBirthDate(result.BirthDate) ? result.BirthDate.substring(0, 10) : '',
            ZipCode: result.ZipCode,
            EmailNotification: result.EmailNotification,
            SmsNotification: result.SmsNotification
          });
          if(this.facilityConfig.collectAddressDuringSignup) {
            this.profileForm.patchValue({
              AddressLine1: result.AddressLine1,
              AddressLine2: result.AddressLine2,
              City: result.City,
              State: result.State,
              Country: result.Country.toLowerCase()
            });
          }
        }
      },
      error: (error) => {
        console.error('Error fetching interested person:', error);
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  async getCompeletedRegistrationSteps() {
    try {
      this.registration = await this._memberService.getCompeletedRegistrationSteps();
      if (this.registration && this.registration.Id) {
        this.isNew = false;
        this.hasProfile = true;
        this.submitted = false;
        this._auth.setProp('registrationCompletedSteps', this.registration.CompletedSteps);
        return this.registration;
      }
    } catch (error) {
      console.error('Error fetching completed registration steps:', error);
      return { CompletedSteps: '' } as Registration;
    }
    return this.registration || ({ CompletedSteps: '' } as Registration);
  }

  phoneChange() {
    this.loginErrorMessage = null;
    if (!this.phoneForm) {
      // Initialize phoneForm if it doesn't exist
      this.phoneForm = new FormGroup({
        PhoneNumber: new FormControl(this.phoneNumber || '', Validators.required),
      });
    }
    let value = this.phoneForm.get('PhoneNumber')?.value || '';
    let phone = parsePhoneNumber(value, <CountryCode>this.countryCode.toUpperCase());
    if (phone?.nationalNumber && (isValidPhoneNumber(phone.nationalNumber, phone.country) || !environment.production && value?.length >= 10)) {
      this.phoneForm.get('PhoneNumber')?.setValue(phone.formatNational());
      this.phoneValue = phone.number;
      this.phoneNumber = phone.nationalNumber;
      this.dialCode = `+${phone.countryCallingCode}`;
    } else {
      this.phoneValue = '';
      this.phoneNumber = '';
    }
  }

  formattedPhoneNumber(): string {
    if (this.phoneValue) {
      let phone = parsePhoneNumber(this.phoneValue, <CountryCode>this.countryCode.toUpperCase());
      if (phone?.isValid)
        return `${this.dialCode} ${phone.formatNational()}`;
    }
    return this.phoneValue;
  }

  signupMember(phone: string, dialCode: string): Observable<any> {
    return this._auth.signup(phone, dialCode)
      .pipe(
        takeUntil(this._unsubscribe),
        tap(async (jwt: any) => {
          if (jwt && jwt.access_token) {
            this.setToken(jwt);
            this.isNew = true;
          }
          if (this.phoneNumber.startsWith('555')) {
            this.submitted = false;
            this.allowClosingPopup = true;
            this.loginStep = 'verify';
          }
        }),
        catchError((err: any) => {
          if (err.status === 428) {
            this.allowClosingPopup = true;
            this.loginStep = 'verify';
            this.submitted = false;
            return of([]);
          }
          this.submitted = false;
          return throwError(err);
        })
      );
  }

  get verificationCodeLength(): number {
    // OTP codes are 6 digits (Auth0 / SMS).
    // Some facility config values appear to be stale/misconfigured (e.g., 4),
    // so enforce a minimum of 6 to avoid truncating input / disabling Confirm.
    return Math.max(this.facilityConfig?.verificationCodeLength ?? 6, 6);
  }

  hasPhone(): boolean {
    return !!this.phoneNumber;
  }

  phoneKeyPress(e: any) {
    if (e.keyCode == 13) this.enterPhone();
  }

  codeChange(value: string) {
    // Keep OTP as a string so leading zeros are preserved.
    const digitsOnly = (value || '').replace(/\D/g, '');
    this.codeValue = digitsOnly.substring(0, this.verificationCodeLength);
  }

  async codeKeyPress(e: any) {
    if (e.keyCode == 13) await this.enterCode();
  }

  setToken(jwt: any) {
    this._auth.setProp('token', jwt.access_token);
  }

  get profileIsDisabled(): boolean {
    return !this.profileForm.valid || !this.profileForm.controls['AgreeToTerms'].value;
  }

  fetchUserInfo(existsCallback: Function = () => { }, newUserCallback: Function = () => { }) {
    const fetchObs = this._userService.fetchUser();
    if (!fetchObs) {
      this.isNew = true;
      this.hasProfile = false;
      this.submitted = false;
      newUserCallback();
      return;
    }

    fetchObs.pipe(
      takeUntil(this._unsubscribe),
      tap((user: any) => {
        this._auth.setProp('user', user);
        if (!user.Email || !user.FirstName || !user.LastName) {
          this.isNew = true;
          this.hasProfile = false;
          this.submitted = false;
          newUserCallback();
          return;
        }
        this.showWelcome();
        this.submitted = false;

        segment.identify(user);

        existsCallback();
      }),
      catchError((err: any) => {
        console.error('fetchUserInfo error', err);
        this.isNew = true;
        this.hasProfile = false;
        this.submitted = false;
        this.cdRef.detectChanges();
        newUserCallback();
        return of(null);
      })
    )
    .subscribe();
  }

  showGetStartedDialog() {
    this.loginStep = 'get-started';
    this.allowClosingPopup = true;
    this.title = `Welcome to ${this.facilityConfig.name}!`;
    this.loginText = 'Feel free to book a class or visit us for a workout to start!';
    this.isLoading = false;
    this.submitted = false;
  }

  showWelcome() {
    this.loginStep = 'welcome';
    setTimeout(() => {
      this.showGetStarted
        ? (
          !this.hasProfile
            ? this.loginStep = 'get-started'
            : this.viewSchedule()
        )
        : (() => {
            // Ensure redirectTo is set before dismissing
            if (!this.redirectTo) {
              this.redirectTo = this.facilityConfig.postRegistrationRedirectTo || '/class-schedule';
            }
            this.dismiss();
          })();
      if (this.loggedIn)
        this.loggedIn.emit(true);
    }, 1000);
  }

  viewSchedule() {
    // Use redirectTo if set, otherwise use config or default to class schedule
    const redirectPath = this.redirectTo || this.facilityConfig.postRegistrationRedirectTo || '/class-schedule';
    // Set redirectTo so dismiss() will use it
    if (!this.redirectTo) {
      this.redirectTo = redirectPath;
    }
    // dismiss() will navigate using redirectTo if set
    this.dismiss();
  }

  async fetchMemberInfo(): Promise<boolean> {
    try {
      const member: any = await firstValueFrom(
        this._userService.fetchMember()!.pipe(takeUntil(this._unsubscribe))
      );
      if (member == undefined) return true;

      const hold = await this._auth.getMemberHold(member.Id);
      if (hold && hold.Action === 1) {
        this._auth.logout('suspended');
        this.loginErrorMessage = 'Your account has been suspended. Please contact support for assistance.';
        this.loginStep = 'phone';
        this.submitted = false;
        this.isLoading = false;
        this.cdRef.detectChanges();
        return false;
      }

      this.memberInfo = member;
      this._auth.setProp('member', member);

      if (member.LocationId) {
        try {
          const location: Location = await this._facilityService.getLocationById(member.LocationId);
          this.localStorageService.setLocation(location);
        } catch (err) {
          console.error('Error fetching location:', err);
        }
      }

      this._userService.fetchAvatar(member.Id)?.pipe(
        takeUntil(this._unsubscribe),
        tap((avatar: any) => {
          this.submitted = false;
          if (avatar) {
            this._auth.setProp('avatar', avatar);
          }
        }),
        catchError(() => {
          return of(null);
        })
      ).subscribe();

      return true;
    } catch (err) {
      console.error('Error fetching member info:', err);
      return true;
    }
  }

  async setRegistrationPhone() {
    try {
      if (!this.isNew && this.registration && this.registration.Id) {
        return;
      }
      await this._auth.registerPhone(this.phoneNumber, this.dialCode);
    } catch (err) {
      console.error('Error in setRegistrationPhone', err);
    }
  }

  async enterCode() {
    this.submitted = true;
    this.isLoading = false;
    if (this.phoneNumber.startsWith('555')) {
      segment.track(segment.TRACK_EVENTS.regStep2, {
        phone: this.dialCode + this.phoneNumber
      });
      this.registration = await this.getCompeletedRegistrationSteps();
      if (Utils.hasStepCompleted(this.registration.CompletedSteps, 'phone')) {
        const isActive = await this.fetchMemberInfo();
        if (!isActive) return true;
      }
      if (!Utils.hasStepCompleted(this.registration.CompletedSteps, 'phone')) {
        this.isNew = true;
        await this.setRegistrationPhone();
        this.memberInfo = await this._memberService.getMember();
      }
      
      if (!Utils.hasStepCompleted(this.registration?.CompletedSteps || '', 'profile')) {
        this.submitted = false;
        this.isLoading = false;
        this.cdRef.detectChanges();
        this.newUserCallback();
      } else {
        this.fetchUserInfo(
          () => {
            // Success callback
          },
          () => {
            this.submitted = false;
            this.showWelcome();
          }
        );
      }
      this.isLoading = false;
    }
    else {
      this._auth.verify(this.phoneNumber, this.codeValue, this.dialCode)
        .pipe(
          takeUntil(this._unsubscribe),
          tap(async (jwt: any) => {
            if (jwt && jwt.access_token) {
              segment.track(segment.TRACK_EVENTS.regStep2, {
                phone: this.dialCode + this.phoneNumber
              })
              this.setToken(jwt);
              await this.setRegistrationPhone();
              const isActive = await this.fetchMemberInfo();
              if (!isActive) return;
              if (!this.registration || !this.registration.Id) {
                this.registration = await this.getCompeletedRegistrationSteps();
              }

              if (!Utils.hasStepCompleted(this.registration?.CompletedSteps || '', 'profile')) {
                this.submitted = false;
                this.isLoading = false;
                this.cdRef.detectChanges();
                this.newUserCallback();
                return;
              }
              if (this.redirectTo && this.redirectTo !== '') {
                this.submitted = false;
                this.isLoading = false;
                window.location.href = this.redirectTo;
                return;
              }
              this.fetchUserInfo(() => {}, () => {
                this.submitted = false;
                this.showWelcome();
              });
            }
            this.submitted = false;
            this.isLoading = false;
            this.dismiss();
          }),
          catchError(() => {
            this.loginStep = 'error';
            this.submitted = false;
            this.isLoading = false;
            return of(null);
          })
        )
        .subscribe();
    }
    return true;
  }

  async registerMember() {
    this.isNew = false;
    this.submitted = true;
    this.isLoading = true;
    this._auth.setProp('DialCode', this.dialCode);
    this._auth.setProp('CountryCode', this.countryCode);
    this._auth.setProp('PhoneNumber', this.phoneNumber);

    // Build personInfo with Id, Guid and timestamp fields for Member/Profile API
    const existing = this.personInfo || {};
    const form = this.profileForm.controls;
    this.personInfo = {
      ...existing,
      Id: existing.Id ?? this.memberInfo?.PersonId ?? 0,
      Guid: existing.Guid ?? this.memberInfo?.PersonGuid ?? '00000000-0000-0000-0000-000000000000',
      CreatedAt: existing.CreatedAt ?? new Date(),
      CreatedBy: existing.CreatedBy ?? this.memberInfo?.Guid ?? '',
      LastModified: existing.LastModified ?? new Date(),
      LastModifiedBy: existing.LastModifiedBy ?? this.memberInfo?.Guid ?? '',
      DialCode: this.dialCode,
      PhoneNumber: this.phoneNumber,
      Gender: form['Gender'].value,
      FirstName: form['FirstName'].value,
      LastName: form['LastName'].value,
      Email: form['Email'].value,
      GenderStr: this.genderMap[form['Gender'].value] || '',
      BirthDate: form['BirthDate'].value,
      ZipCode: form['ZipCode'].value
    };

    if (!this.memberInfo) {
      this.memberInfo = await this._memberService.getMember();
    }

    if (!this.profileForm.valid) {
      Object.values(this.profileForm.controls).forEach(control => control.markAsTouched());
      this.submitted = false;
      this.isLoading = false;
      return false;
    }

    const controls = this.profileForm.controls;
    // Build addressInfo
    this.addressInfo = {
      Id: this.memberInfo.BillingAddressId || 0,
      Guid: uuidv4(),
      Name: "",
      AddressLine1: this.facilityConfig.collectAddressDuringSignup ? (controls['AddressLine1']?.value || '') : '',
      AddressLine2: this.facilityConfig.collectAddressDuringSignup ? (controls['AddressLine2']?.value || '') : '',
      City: this.facilityConfig.collectAddressDuringSignup ? (controls['City']?.value || '') : '',
      State: this.facilityConfig.collectAddressDuringSignup ? (controls['State']?.value || '') : '',
      Country: this.facilityConfig.collectAddressDuringSignup ? (controls['Country']?.value || '') : '',
      ZipCode: controls['ZipCode'].value || '',
      Latitude: controls['Latitude']?.value || 0,
      Longitude: controls['Longitude']?.value || 0,
      AddressStr: "",
      CreatedAt: new Date(),
      CreatedBy: this.memberInfo.Guid
    };

    // Build registrationProfile
    const registrationProfile : RegistrationProfile = {
      FirstName: controls['FirstName'].value,
      LastName: controls['LastName'].value,
      EmailAddress: controls['Email'].value,
      Gender: controls['Gender'].value,
      BirthDate: controls['BirthDate'].value,
      ZipCode: controls['ZipCode'].value,
      EmailNotification: controls['EmailNotification'].value,
      SmsNotification: controls['SmsNotification'].value,
      AgreeToTerms: controls['AgreeToTerms'].value,
      RegistrationId: this.registration.Id,
      RegistrationGuid: this.registration.Guid,
      CreatedAt: new Date(),
      CreatedBy: this.memberInfo.Guid,
      Guid: uuidv4(),
      Id: 0,
    };

    segment.track(segment.TRACK_EVENTS.regStep3, {
      first_name: controls['FirstName'].value,
      last_name: controls['LastName'].value,
      email: controls['Email'].value,
      dob: controls['BirthDate'].value,
      gender: controls['Gender'].value,
      address_line_1: this.facilityConfig.collectAddressDuringSignup ? (controls['AddressLine1']?.value || '') : '',
      address_line_2: this.facilityConfig.collectAddressDuringSignup ? (controls['AddressLine2']?.value || '') : '',
      city: this.facilityConfig.collectAddressDuringSignup ? (controls['City']?.value || '') : '',
      state: this.facilityConfig.collectAddressDuringSignup ? (controls['State']?.value || '') : '',
      country: this.facilityConfig.collectAddressDuringSignup ? (controls['Country']?.value || '') : '',
      zip_code: controls['ZipCode']?.value,
      email_notification: controls['EmailNotification'].value,
      sms_notification: controls['SmsNotification'].value,
      agree_to_terms: controls['AgreeToTerms'].value,
    });

    var registrationProfileResult: MemberProfileSaveRequest = {
      MemberId: this.memberInfo.Id,
      Person: this.personInfo,
      Address: this.addressInfo,
      EmailNotification: controls['EmailNotification'].value,
      SmsNotification: controls['SmsNotification'].value
    }

    await new Promise<void>((resolve) => {
      this._memberService.saveProfile(registrationProfileResult).subscribe(async () => {
        this.registration = await this.getCompeletedRegistrationSteps();
        this.fetchUserInfo();
        // Save address if required
        if(this.facilityConfig.collectAddressDuringSignup) {
          const request: MemberAddressSaveRequest = {
            MemberId: this.memberInfo.Id,
            Address: this.addressInfo
          };
          this._memberService.changeBillingAddress(request).subscribe(async member => {
            if (member && member.Id) {
              this.memberInfo = member;
              await this.fetchMemberInfo();
            }
            resolve();
          });
        } else {
          resolve();
        }
        
        await new Promise<void>((resolveAgreement) => {
          this.getAgreementDocuments().subscribe(docs => {
            this.memberDocs = docs;
            if(this.memberDocs.filter(doc => !doc.AgreeStatus).length === 0) {
                // Set redirect from config or default to class schedule
                this.redirectTo = this.facilityConfig.postRegistrationRedirectTo || '/class-schedule';
                this.submitted = false;
                this.isLoading = false;
                // showWelcome() will handle the dismiss and redirect after showing welcome screen
                this.showWelcome();
                resolveAgreement();
            } else {
                // Agreements are needed, so we stay in agreement step
                // Don't set redirectTo yet - it will be set after agreements are submitted
                resolveAgreement();
            }
          });
        });
      });
    });

    this.submitted = false;
    this.isLoading = false;
    // Only set redirect and dismiss if we're not already showing welcome/get-started/agreement screens
    // showWelcome() handles its own redirect after the welcome screen timeout
    if (this.loginStep !== 'welcome' && this.loginStep !== 'get-started' && this.loginStep !== 'agreement') {
      // Redirect after successful registration (if not already set)
      // Use config value or default to class schedule
      if (!this.redirectTo) {
        this.redirectTo = this.facilityConfig.postRegistrationRedirectTo || '/class-schedule';
      }
      this.dismiss();
    }
    return true;
  }

  getAgreementDocuments(): Observable<MemberDocument[]> {
    // Show agreement if needed
    this.isLoading = true;
    if (this.interestedPerson && this.interestedPerson.MenuPackId && this.interestedPerson.MenuPackId !== 0 && this.interestedPerson.PurchaseId !== '') {
      const req: MemberDocumentRequest = {
        MemberId: this.memberInfo.Id,
        DocumentEventType: DocumentEventType.Checkout,
        Intent: DocumentIntent.MenuPack,
        IntentId: this.interestedPerson.MenuPackId
      };
      return this._memberService.getNonAgreedDocuments(req).pipe(
        tap((response: RepositoryResult<MemberDocument[]>) => {
          if(response && response.Success && response.Data) {
            this.memberDocs = response.Data;
            if (this.memberDocs && this.memberDocs.filter(c => c.AgreeStatus == null || c.AgreeStatus === false).length > 0) {
              this.loginStep = 'agreement';
              this.allowClosingPopup = false;
              this.title = this.memberDocs.length > 0 ? 'Agreement' : 'Agreements';
              this.loginText = '';
            }
            this.isLoading = false;
          }
        }),
        // Map the RepositoryResult to just the Data array, or [] if not present
        // This ensures the return type is Observable<MemberDocument[]>
        // and fixes the type error
        // You need to import 'map' from 'rxjs/operators' at the top if not already imported
        map((response: RepositoryResult<MemberDocument[]>) => (response && response.Success && response.Data) ? response.Data : [])
      );
    }
    this.isLoading = false;
    return of([]);
  }
      
  private handleError(err: any) {
    this.loginStep = 'error';
    this.submitted = false;
  }

  flag(): string {
    return `https://dropfitness-static.nyc3.digitaloceanspaces.com/static/svg/flags/4x3/${this.countryCode}.svg`;
  }

  /** Keep dial + flag in sync; +1 prefers US over Canada. */
  private applyDialCountry(dialCode?: string, countryCode?: string): void {
    this.dialCode = dialCode || '+1';
    if (countryCode) {
      this.countryCode = countryCode;
    } else {
      const country = CountryOptions.findByDialCode(this.dialCode);
      if (country) {
        this.countryCode = country.code;
      } else {
        this.countryCode = 'us';
      }
    }
    this.flagUrl = `https://dropfitness-static.nyc3.digitaloceanspaces.com/static/svg/flags/4x3/${this.countryCode}.svg`;
  }

  changeCountry(ctry: any) {
    this.applyDialCountry(ctry.phoneCode, ctry.country);
    this.phoneForm.patchValue({ DialCode: this.dialCode });
    this.localStorageService.setProp('df-auth-key', 'DialCode', this.dialCode);
    this.localStorageService.setProp('df-auth-key', 'CountryCode', this.countryCode);
  }

  isInvalid(controlName: string): boolean {
    const control = this.profileForm.controls[controlName];

    // Special validation for BirthDate
    if (controlName === 'BirthDate' && control.value) {
      const birthDate = new Date(control.value);
      const minDate = new Date(this.minDOB());
      const maxDate = new Date(this.maxDOB());

      // Check if birth date is outside the valid range
      if (birthDate < minDate || birthDate > maxDate) {
        return true;
      }
    }

    return control.invalid && (control.dirty || control.touched);
  }

  minDOB(): string {
    let today = new Date();
    return `${today.getFullYear() - 100}-${(today.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}-${today.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`;
  }

  maxDOB(): string {
    const today = new Date();
    const minAge = this._environmentService.getMinimumAge();
    return `${today.getFullYear() - minAge}-${(today.getMonth() + 1).toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}-${today.getDate().toLocaleString('en-US', {minimumIntegerDigits: 2, useGrouping:false})}`;
  }

  isValidBirthDate(birthDate: string): boolean {
    if (!birthDate) return false;

    // Check for default/invalid dates
    const invalidDates = ['0001-01-01', '0001/01/01', '1900-01-01', '1900/01/01'];
    if (invalidDates.includes(birthDate.substring(0, 10))) return false;

    // Check if it's a valid date and within reasonable range
    const date = new Date(birthDate);
    const minDate = new Date(this.minDOB());
    const maxDate = new Date(this.maxDOB());

    return date >= minDate && date <= maxDate && !isNaN(date.getTime());
  }

  goToMobileEnterScreen() : void {
    this.submitted = true;
    this.loginStep = 'phone';
    this.allowClosingPopup = true;
    this.submitted = false;
    this.loginErrorMessage = null;
  }

  resendCode() : void {
    this.enterPhone();
  }

  onModalClose(modal: any) {
    if(this.loginStep === 'register' || this.loginStep === 'agreement') {
      return;
    }
    modal.dismiss('Cross click');
  }

  onAgreementAcceptanceChange(event: Event) {
    const target = event.target as HTMLInputElement;
    this.agreementForm.controls['AgreeToTerms'].setValue(target.checked);
  }

  get agreementIsDisabled(): boolean {
    return !this.agreementForm.valid || !this.agreementForm.controls['AgreeToTerms'].value;
  }

  openDocumentPreview(memberDocument: MemberDocument) {
    const modalRef = this.modalService.open(PdfPreviewComponent, {
      size: 'lg',
      centered: true,
      fullscreen: window.innerWidth <= 768,
      windowClass: 'pdf-preview-modal'
    });
    modalRef.componentInstance.pdfUrl = memberDocument.UploadedUrl;
    modalRef.componentInstance.pdfName = memberDocument.Document?.Name;
  }

  submitAgreement()
  {
    if(this.agreementIsDisabled)
      return;
    this.submitted = true;
    this.isLoading = true;
    
    const req: MemberDocumentAgreeRequest = {
      MemberId: this.memberInfo.Id,
      MemberDocumentIds: this.memberDocs.filter(d => !d.AgreeStatus).map(d => d.Id)
    };
    this._memberService.agreeToMemberDocument(req).subscribe({
      next: (res) => {
        this.memberDocs = res;
      },
      error: (err) => {
        this.loginStep = 'error';
        this.submitted = false;
        this.isLoading = false;
        return;
      },
      complete: () => {
        this.submitted = false;
        this.isLoading = false;
        this.showGetStarted = true;
        // Set redirect from config or default to class schedule
        if (!this.redirectTo) {
          this.redirectTo = this.facilityConfig.postRegistrationRedirectTo || '/class-schedule';
        }
        this.showWelcome();
      }
    });
  }
}
